/*!

=========================================================
* Argon Dashboard PRO React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// reactstrap components
import { Container, Row, Col } from 'reactstrap'

function TimelineHeader({ name, description }) {
  return (
    <>
      <div className="header header-dark content__title content__title--calendar">
        <Container fluid>
          <div className="header-body">
            <Row className="d-flex align-items-center py-4">
              <Col lg="6" xs="7">
                <h6 className="h2 d-inline-block mb-0 text-primary neue-bold letter-2">
                  {name}
                </h6>{' '}
                <p className="text-primary mt-2 mb-0 neue-thin letter-4">
                  {description}
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string
}

export default TimelineHeader
